import React from 'react';
import styles from './illustrations.module.css';
import CardTitle from '../../../../lib/component/cardTitle/cardTitle';
import { Link } from 'react-router-dom';
import statisticsApi from '../../../../lib/statisticsApi';
import { BoutiqueItem } from '../../js/interface';

export default ({ title, bdArr }: { title: string; bdArr: BoutiqueItem[] }) => {
  return (
    <div className={styles.illustrations}>
      {title && <CardTitle {...{ title: title, tip: '', fn: () => {} }}></CardTitle>}
      <div className={styles.illustrationsContent}>
        {bdArr.map((item, index) => {
          return (
            <Link
              to={`/subjectDetails?id=${item?.subject?.subject_id}`}
              className={styles.illustration}
              style={{ backgroundImage: `url(${item.subject?.cover_url})` }}
              key={index}
              onClick={() => {
                statisticsApi.statisticsApi(26);
              }}
            ></Link>
          );
        })}
      </div>
    </div>
  );
};
